export default {
  EQuickAccessItems: {
    QUICKACCESS: -1,
    SHAREDDOCUMENTS: -2,
    DIGITALIZATIONS: -3,
    CHECKOUTS: -4,
    FAVORITES: -5,
    TRASHCAN: -6,
    PUBLICLINKS: -7,
    MYDEADLINES: -8,
  },
};
